module.exports = __webpack_public_path__ + "static/media/ringProgress.9256a86e.svg";